export default "__VITE_ASSET__f58043dc__"